import { makeStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles(({ palette, custom }: Theme) => ({
  icon: {
    position: 'absolute',
    top: '55%',
    transform: 'translateY(-55%)',
    left: 11,
    zIndex: 1,
    height: 22,
    width: 22,
    fill: palette.primary.main,
  },
  iconLarger: {
    width: 24,
  },
  activeIcon: {
    color: palette.primary.main,
  },
  adornmentIcon: {
    fontSize: 22,
    color: palette.primary.main,
  },
  adornmentPrefix: {
    marginLeft: 8,
    fontSize: 14,
    lineHeight: 'normal',
    color: custom.grey[3],
  },
  withAdornment: {
    '& .MuiInputLabel-outlined:not(.MuiInputLabel-shrink)': {
      marginLeft: 30,
    },
  },
  label: {
    marginBottom: 2,
    transform: 'scale(1) translate3d(30px, 45px, 0)',
  },
  labelDense: {
    marginBottom: -7,
    transform: 'scale(1) translate3d(30px, 45px, 0)',
  },
  textField: {
    paddingLeft: 40,
  },
  input: {
    paddingTop: 15.5,
    paddingBottom: 15.5,
    height: 15,
    lineHeight: 'normal',
  },
  inputLarger: {
    fontSize: 18,
    color: custom.grey[2],
    paddingTop: 20,
    paddingBottom: 20,
    '&:placeholder': {
      fontSize: 18,
    },
  },
  inputAdornment: {
    fontSize: 14,
    lineHeight: 'normal',
  },
  inputAdornmentLarger: {
    fontSize: 18,
    lineHeight: 1,
    color: custom.grey[2],
  },
  lockIcon: {
    color: '#18a555',
  },
  lockOutlinedIcon: {
    color: custom.green[1],
    marginRight: 5,
  },
  tipMessageGreen: {
    padding: '15px !important',
    backgroundColor: `${custom.status.success.light} !important`,
    lineHeight: 1.43,
  },
}));
